var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'signalr';
import { createSignalRHubConnection } from '../utilities';
export class PhotoCaptureIntelligentDamageConnectionService {
    constructor(signalRHubConnectionFactory = createSignalRHubConnection) {
        this.signalRConnection = null;
        this.signalRHubProxy = null;
        this.signalRHubConnectionFactory = signalRHubConnectionFactory;
    }
    /**
     * Creates and stores the SignalR hub connection.
     * The caller (saga) is responsible for calling start() and reading the resolved connection id.
     * @returns Promise resolving once the connection object is ready
     */
    negotiateDamageConnection() {
        return __awaiter(this, void 0, void 0, function* () {
            // Reuse existing connection to keep SignalR alive across upload/take-photo user interactions.
            if (this.signalRConnection) {
                return;
            }
            const signalRConnection = this.signalRHubConnectionFactory();
            this.signalRConnection = signalRConnection;
        });
    }
    getActiveDamageConnection() {
        return this.signalRConnection;
    }
    disconnectDamageConnection() {
        const activeConnection = this.signalRConnection;
        this.signalRHubProxy = null;
        this.signalRConnection = null;
        if (!activeConnection) {
            return;
        }
        activeConnection.__isManualStop = true;
        activeConnection.stop();
    }
    initializeDamageHubProxy(hubName) {
        if (!this.signalRConnection) {
            return null;
        }
        if (this.signalRHubProxy) {
            return this.signalRHubProxy;
        }
        this.signalRHubProxy = this.signalRConnection.createHubProxy(hubName);
        return this.signalRHubProxy;
    }
    getActiveDamageHubProxy() {
        return this.signalRHubProxy;
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureDamageConnectionService.js.map